// Libraries
import React from "react";
import { EditableInput, useObserver, useState, useContext } from "@shoothill/core";
import * as Mui from "@material-ui/core";
import { StoresContext, Stores } from "Globals/Stores";
// Custom
import AdminApplicantViewModel from "Globals/ViewModels/Applicant/AdminApplicantViewModel";
import { CustomInput } from "Globals/Styles/AppStyling";

// Components

// Styling & images
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import { Box, Button, Modal } from "@material-ui/core";
import styled from "styled-components";
import { CrossSVG } from "Globals/Views/IconSVGs/CrossSVG";
// TODO Move styles to separate file
// TODO implement theme colors instead of hardcoded hex values
export const ModalBase: any = styled(Modal)`
    padding: 0px;
    margin: 10% auto;
    flex-direction: column;
    display: flex;
    max-width: 375px;

    .modalhead,
    .modalbody {
        padding: 10px 15px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }

    .modalhead {
        border-radius: 5px 5px 0px 0px;
        background-color: #dc3545;
        color: white;

        h2 {
            margin: 0 auto;
            font-size: 1.8em;
            text-transform: uppercase;
            font-weight: 500;
        }
    }
    .modalbody {
        border-radius: 0px 0px 5px 5px;
        background-color: rgba(255, 255, 255, 1);
        outline: none;
    }
`;
export const ModelButtonsContainer = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 20px;

    button {
        border-radius: 0px;
        display: flex;
        flex: 1 50%;
        color: white;
        background-color: #3c3c3b;
        font-size: 12px;
    }
    button:first-child {
        color: white;
        background-color: #dc3545;
    }
`;

interface IProps {
    isActive: boolean;
    confirmClose(reason: string, reasonDetail: string): void;
    onCancel(): void;
    viewModel?: AdminApplicantViewModel;
}

export const RejectApplicationModal: React.FC<IProps> = (props) => {
    const domain = useContext<Stores>(StoresContext).Domain;
    const [reason, setReason] = useState("");
    const [reasonDetail, setReasonDetail] = useState("");
    return useObserver(() => (
        <>
            <ModalBase open={props.isActive} onClose={() => props.onCancel()}>
                <div>
                    <Box className="modalhead" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Mui.Typography variant="h6">Reject application</Mui.Typography>
                        <div style={{ cursor: "pointer", marginTop: "5px" }} onClick={() => props.onCancel()}>
                            <CrossSVG />
                        </div>
                    </Box>
                    <div className="modalbody">
                        <p style={{ fontSize: "12px" }}>Rejection reason</p>
                        <Box>
                            <Mui.Select name="Select" value={reason} onChange={(e) => setReason(e.target.value as string)}>
                                <Mui.MenuItem disabled value={""}>
                                    {"Please select"}
                                </Mui.MenuItem>
                                {domain.RejectReasonStore.getRejectReasonOptions.map((option, index) => {
                                    return (
                                        <Mui.MenuItem key={option.key + index} value={option.value}>
                                            {option.key}
                                        </Mui.MenuItem>
                                    );
                                })}
                            </Mui.Select>
                        </Box>
                        {domain.RejectReasonStore.getRejectReasonName(reason) === "Other" && (
                            <>
                                <p style={{ fontSize: "12px" }}>Rejection reason detail</p>
                                <Box>
                                    <CustomInput
                                        viewModel={props.viewModel}
                                        fieldName="rejectReason"
                                        placeHolder="Reason detail"
                                        shrink={true}
                                        multiLine={true}
                                        inputProps={{}}
                                        onChange={(e: any) => setReasonDetail(e.target.value)}
                                    />
                                </Box>
                            </>
                        )}

                        <ModelButtonsContainer>
                            <Mui.Button
                                id="save"
                                variant="contained"
                                disabled={!reason}
                                onClick={() => {
                                    props.confirmClose(reason, reasonDetail);
                                }}
                            >
                                Reject application
                            </Mui.Button>
                            <span style={{ paddingRight: "30px" }} />
                            <Mui.Button
                                id="cancel"
                                variant="contained"
                                onClick={() => {
                                    props.onCancel();
                                }}
                            >
                                Cancel
                            </Mui.Button>
                        </ModelButtonsContainer>
                    </div>
                </div>
            </ModalBase>
        </>
    ));
};
